import * as jsxRuntime from "/Users/damiryusipov/devProjects/jsProjects/github/api-diff-viewer/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment